export default "__VITE_ASSET__CWp9AwWD__"